
<div class="modal-footer updateStatus">
    <div>
      <h3>{{'REVIEW.QUESTION' | translate }}</h3>
    </div>
  
    <button
      type="button"
      class="btn btn-primary approve"
      (click)="submitReview()"
    >
      {{'COMMON.YES' | translate }}
    </button>
    <button type="button" (click)="cancel($event)" class="btn btn-danger">
      {{'COMMON.NO' | translate }}
    </button>
  </div>
  